import React, { useEffect, useState } from 'react';

import { PatientDetails, VideoCallButton } from '../../components/common/patientDetails';
import PatientHandoverSheet from '../../components/common/patientHandoverSheet';

import {
	removePatientById,
	clearData,
	pendingDispenseRemovingPageNumber
} from '../../services/slices/dispense/patientPendingList';

import {
	flexiNotificationRxNumbers,
	onhandleConfirmDelivery,
	onhandleMissedDelivery
} from '../../utils/helper/deliveriesHelper';

import { handleToggleRXData, refreshCurrentLocation } from '../../utils/helper/helper';
import { apiKey, deliveryDriverDeliveredDispense, driver_check_partial_delivered } from '../../networking/urlEndPoints';
import { MissedDeliveryConfirmation } from '../../components/common/routeConfirmation';
import Axios from '../../networking/interceptor';
import { useAuthSelector } from '../../services/selectors/authSelector';

import { useAllSelector } from '../../services/selectors/allSelector';
import { ErrorMessages } from '../../components/error/errorMessages';
import { fetchPatientPendingList } from '../../services/apis/dispense/patientPendingList';

import { useCustomStates } from '../../hooks/useCustomStates';
import { DispenseRxData } from '../../components/common/dispenseRxData';
import { PendingDispenseDeliveredByAnotherDriverAblyHelper } from '../../utils/helper/ablyDeliveredDispenseByOthers';

import { RemoveAllPatchesId } from '../../services/slices/dispense/validateReturnPatches';
import { clearConfirmDeliveryUserMessage } from '../../services/slices/dispense/confirmDelivery';
import { clearUpdateDeliveryUserMessage } from '../../services/slices/dispense/updateDeliveryStatus';

import SortOptionMenu from '../../components/common/SortOptionMenu';
import DriverAppointmentCallPanel from '../../components/common/driverAppointmentCallPanel';
import { DELIVERY_SORT_OPTIONS } from '../../utils/helper/sortUi';
import { openDeliveryPatientOnSignPage } from '../../utils/constants/deliveryPrivacy';
import InfiniteScroll from 'react-infinite-scroll-component';
import SearchBox from '../../components/common/searchBox';

import * as Messages from '../../components/common/AllConfirmationMessages'
import * as routeNames from '../../routes/routeName'
import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';

import * as Hooks from '../../hooks';
import * as Loading from '../../components/common/loader'

import PageNotFound from '../notFound/pageNotFound';

// import { FlexiRxStatusWarningModal } from '../../components/common/rxStatusWarningModal';
import { useSuperVisorSelector } from '../../services/selectors/allSuperVisorSelector';

const PendingDispense = () => {

	const dispatch = Hooks.useCustomDispatch();
	const navigate = Hooks.useCustomNavigate();

	const { pharmacyId, driverID, pharmacyInspectionMode } = useAuthSelector()
	const { patientPendingListResponse, validateReturnedPatchesResponse, pharmacist_assistant_status, confirmDeliveryResponse, updateDeliveryListResponse } = useAllSelector();

	const { comment,
		setComment,

		cordinate,
		setCordinate,

		isRefused,
		setIsRefused,

		openIndex,
		setOpenIndex,

		patientSignature,
		setPatientSignature,

		pharmacistSignature,
		setPharmacistSignature,

		showErrorToast,
		setShowErrorToast,

		loading,
		setLoading,

		showSuccessToast,
		setShowSuccessToast,

		showComment,
		setShowComment,

		showPatientSignature,
		setShowPatientSignature,

		showPharmacistSignature,
		setShowPharmacistSignature,

		showData,
		setShowData,

		apiCallMade,
		setApiCallMade,

		showToast,
		setShowToast,

		missedDeliveryConfirmation,
		setMissedDeliveryConfirmation,

		missedData,
		setMissedData,

		missedExplanation,
		setMissedExplanation,

		missedExplanationError,
		setMissedExplanationError,

		missedDeliverErrorToast,
		setMissedDeliveryErrorToast,

		signatureErrors,
		setSignatureErrors,

		covid19,
		setCovid19,

		isTransferRequest,
		setIsTransferRequest,

		loadMore,
		setLoadMore,

		delveryDoneByAnotherDriver,
		setDeliveryDoneByAnotherDriver,

		missedIndex,
		setMissedIndex,

		patientId,
		setPatientID,

		pId,
		setPId,

		consultation,
		setConsultation,

		newRxCounsellingValues,
		setNewRxCounsellingValues,

		isPatientVerified,
		setIsPatientVerified,

		selectedDoses,
		setSelectedDoses,

		unconsumedDoseEntries,
		setUnconsumedDoseEntries,

		unconsumedDoseErrors,
		setUnconsumedDoseErrors
	} = useCustomStates()

	const [flexiProofImages, setFlexiProofImages] = useState({})
	const [copayPaymentOptions, setCopayPaymentOptions] = useState({})

	const { flexiMarkedNotificationsResponse } = useSuperVisorSelector()

	const [showFlexiConfirmation, setShowFlexiConfirmation] = useState(false)
	const [flexiRxNumbers, setFlexiRxNumbers] = useState([])
	const [deliveryTab, setDeliveryTab] = useState('your')
	const [filterType, setFilterType] = useState('all') // 'all' or 'partial-delivered'
	const [hasPartialDelivered, setHasPartialDelivered] = useState(false)
	const [selectedDeliverRxIds, setSelectedDeliverRxIds] = useState([])
	const [deliverySort, setDeliverySort] = useState('default')
	const currentRequestKey = `${deliveryTab}:${filterType}:${deliverySort}`
	const { getMatchedAppointmentDelivery } = Hooks.useTodayAppointmentDeliveryMap({
		pharmacyId,
		enabled: Boolean(
			pharmacyId &&
			deliveryTab !== 'others' &&
			!patientPendingListResponse?.loading &&
			Array.isArray(patientPendingListResponse?.data) &&
			patientPendingListResponse.data.length > 0
		),
		refreshKey: currentRequestKey,
	})

	const handleDropdownToggle = (index, data) => {
		if (openDeliveryPatientOnSignPage(navigate, data)) {
			return;
		}

		setConsultation(null)
		setNewRxCounsellingValues([])
		setSelectedDoses({})
		setFlexiRxNumbers(data?.patients_win_rx_data)
		// When opening a card, set selected RX IDs to this card's prescriptions immediately so we never show previous card's ids
		if (openIndex !== index) {
			refreshCurrentLocation(setCordinate)
			const rxIds = data?.patients_win_rx_data?.map((r) => r.id).filter(Boolean) || []
			setSelectedDeliverRxIds(rxIds)
		}
		handleToggleRXData(
			index,
			data,
			openIndex,
			setOpenIndex,
			dispatch,
			setSignatureErrors,
			setShowData,
			RemoveAllPatchesId,
			setPatientSignature,
			setShowComment,
			setShowPatientSignature,
			setShowPharmacistSignature,
			setPharmacistSignature,
			setComment,
			setIsPatientVerified,
			setUnconsumedDoseEntries,
			setUnconsumedDoseErrors,
			setMissedExplanation,
			setMissedExplanationError,
			setPId,
			pharmacyId
		)
	}

	// Check for partial delivered records in background
	useEffect(() => {
		if (pharmacyId) {
			const checkPartialDelivered = async () => {
				try {
					const response = await Axios.get(driver_check_partial_delivered, {
						params: { pharmacy_id: pharmacyId }
					})
					if (response?.data?.success && response?.data?.data?.partial_record === true) {
						setHasPartialDelivered(true)
					} else {
						setHasPartialDelivered(false)
					}
				} catch (error) {
					console.error('Error checking partial delivered:', error)
					setHasPartialDelivered(false)
				}
			}
			checkPartialDelivered()
		}
		return () => { }
	}, [pharmacyId])

	useEffect(() => {
		if (pharmacyId) {
			setLoading(true)
			dispatch(clearData())
			dispatch(pendingDispenseRemovingPageNumber())
			const params = {
				page: 1,
				pharmacy_id: pharmacyId,
				setLoading: setLoading,
				tab: deliveryTab,
				delivery_sort: deliverySort,
				currentRequestKey
			}
			if (filterType === 'partial-delivered') {
				params.type = 'partial-delivered'
			}
			dispatch(fetchPatientPendingList(params))
			setApiCallMade(true)
		}
		return () => { }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pharmacyId, filterType, deliveryTab, deliverySort])

	const handleConfirmDelivery = (patientData, index) => {

		// const matchedFlexiData = flexiNotificationRxNumbers(flexiMarkedNotificationsResponse,
		// 	patientData?.patients_win_rx_data, patientData.id)
		// if (matchedFlexiData && matchedFlexiData.length > 0) {
		// 	setFlexiRxNumbers(matchedFlexiData);
		// 	setShowFlexiConfirmation(true);
		// 	return;
		// }

		onhandleConfirmDelivery(patientData,
			index,
			pharmacyId,
			null,
			patientSignature,
			pharmacistSignature,
			cordinate,
			comment,
			dispatch,
			setLoading,
			setOpenIndex,
			setShowErrorToast,
			setShowSuccessToast,
			pharmacyInspectionMode,
			isRefused,
			covid19,
			'pending_dispense',
			setIsRefused,
			setSignatureErrors,
			validateReturnedPatchesResponse,
			isTransferRequest,
			setIsTransferRequest,
			pharmacist_assistant_status,
			consultation,
			newRxCounsellingValues,
			selectedDoses,
			flexiProofImages,
			copayPaymentOptions,
			null,
			isPatientVerified,
			selectedDeliverRxIds,
			unconsumedDoseEntries,
			setUnconsumedDoseErrors
		);
	}

	useEffect(() => {
		const matchedFlexiData = flexiNotificationRxNumbers(flexiMarkedNotificationsResponse, flexiRxNumbers, pId)
		if (matchedFlexiData && matchedFlexiData.length > 0) {
			setShowFlexiConfirmation(true);
		} else {
			setShowFlexiConfirmation(false);
		}
		return () => { }
	}, [pId, flexiRxNumbers, flexiMarkedNotificationsResponse])

	const handleMissedDelivery = () => {
		onhandleMissedDelivery(pharmacyId,
			missedData,
			missedIndex,
			dispatch,
			setOpenIndex,
			setMissedDeliveryErrorToast,
			setMissedDeliveryConfirmation,
			missedExplanation,
			setMissedExplanation,
			setMissedExplanationError,
			"today_missed",
			"pending_dispense",
			selectedDoses,
			selectedDeliverRxIds,
			cordinate)
	}

	const fetchMoreData = () => {
		if (patientPendingListResponse?.currentPage < patientPendingListResponse?.totalPages) {
			setLoadMore(true)
			const params = {
				page: patientPendingListResponse?.currentPage + 1,
				pharmacy_id: pharmacyId,
				setLoading: setLoading,
				setLoadMore: setLoadMore,
				tab: deliveryTab,
				delivery_sort: deliverySort,
				currentRequestKey
			}
			if (filterType === 'partial-delivered') {
				params.type = 'partial-delivered'
			}
			dispatch(fetchPatientPendingList(params))
		}
	}

	const refreshPendingDispense = () => {
		if (!pharmacyId || patientPendingListResponse?.loading) return
		setOpenIndex(null)
		setLoading(true)
		dispatch(clearData())
		dispatch(pendingDispenseRemovingPageNumber())
		const params = {
			page: 1,
			pharmacy_id: pharmacyId,
			setLoading,
			tab: deliveryTab,
			delivery_sort: deliverySort,
			currentRequestKey
		}
		if (filterType === 'partial-delivered') params.type = 'partial-delivered'
		dispatch(fetchPatientPendingList(params))
	}

	return (
		<>
			{pharmacyId ? <>
				{patientPendingListResponse?.data?.length > 0 &&
					<InfiniteScroll
						dataLength={patientPendingListResponse?.data?.length}
						next={fetchMoreData}
						hasMore={patientPendingListResponse?.currentPage <= patientPendingListResponse?.totalPages}
					/>
				}

				<div className="app-wrapper flex justify-center">
					<div className="app-screen no-shades w-full xl:w-3/12 lg:w-4/12 md:w-5/12 sm:w-6/12 h-full overflow-x-hidden">
						<div className="relative p-4" >
							<Common.TopBar />
							<div className="flex gap-3 mb-3">
								<SearchBox pharmacyId={pharmacyId} onRefresh={refreshPendingDispense} isRefreshing={patientPendingListResponse?.loading && loading} />
							</div>


							<div className="title-row my-2 flex items-center justify-between gap-2" >
								<h1 className="text-xl font-bold">Today's Pending Dispense</h1>
								<SortOptionMenu
									options={DELIVERY_SORT_OPTIONS}
									value={deliverySort}
									onChange={setDeliverySort}
									ariaLabel="Delivery sorting"
								/>
							</div>

							<Common.YourOthersTabs value={deliveryTab} onChange={setDeliveryTab} />

							<div className='flex gap-2 mb-3'>
								{['all', 'partial-delivered'].map(type => (
										<button
											key={type}
											className={`p-2 h-10 flex items-center justify-center text-sm font-medium rounded-lg flex-1 ${
												filterType === type ? 'text-white' : 'bg-gray-200 text-gray-700'
											}`}
											style={filterType === type ? { backgroundColor: '#FEAE02' } : {}}
											onClick={() => setFilterType(type)}
										>
											{type === 'all' ? 'All' : 'Partial Delivered'}
										</button>
									))}
							</div>

							<div className="routes-list">

								{(patientPendingListResponse?.loading && loading) ?

									<div className='flex justify-center h-96'>
										<Loading.LoadingView />
									</div> :

									patientPendingListResponse?.error !== null ?
										<div className='flex  justify-center pb-4 mb-4'>
											<ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
										</div> :

										(patientPendingListResponse?.data?.length === 0 && !patientPendingListResponse?.loading) ?
											<p className='flex  justify-center pb-4 pt-3 h-96'>
												{filterType === 'partial-delivered'
													? `No partial delivered deliveries in ${deliveryTab === 'your' ? 'Your' : deliveryTab === 'transferred' ? 'Transferred' : 'Others'}.`
													: deliveryTab === 'your'
														? 'No deliveries in your route.'
														: deliveryTab === 'transferred'
															? 'No transferred deliveries.'
															: 'No deliveries assigned to others'}
											</p>
											:

											patientPendingListResponse?.data?.map((data, index) => {
												const noRxSelected = !selectedDeliverRxIds || selectedDeliverRxIds.length === 0;
												const isRouteAllowed = data.route_access?.allowed !== false;
												const appointmentDelivery = deliveryTab !== 'others' && isRouteAllowed ? getMatchedAppointmentDelivery(data) : null;
												return (
												<React.Fragment key={index}>

													<div className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3" id={`patientCard-${index}`}>
														<PatientDetails
															data={data}
															patientImg={data.profile_image}
															totalRxData={data?.patients_win_rx_data?.length}
															index={index}
															openIndex={openIndex}
															onDropdownToggle={handleDropdownToggle}
															headerAction={<PatientHandoverSheet patient={data} eligible={deliveryTab === 'your' && isRouteAllowed && data?.delivery_status !== 'delivered'} />}
															hideVideoCallButton={deliveryTab === 'others'}
														>
															<>
																<DispenseRxData
																	rxData={data?.patients_win_rx_data}
																	signatureErrors={signatureErrors}
																	type="new_rx"
																	newRxCounsellingValues={newRxCounsellingValues}
																	setNewRxCounsellingValues={setNewRxCounsellingValues}
																	patientData={data}
																	selectedDoses={selectedDoses}
																	setSelectedDoses={setSelectedDoses}
																	flexiProofImages={flexiProofImages}
																	setFlexiProofImages={setFlexiProofImages}
																copayPaymentOptions={copayPaymentOptions}
																setCopayPaymentOptions={setCopayPaymentOptions}
																selectedDeliverRxIds={selectedDeliverRxIds}
																setSelectedDeliverRxIds={setSelectedDeliverRxIds}
																unconsumedDoseEntries={unconsumedDoseEntries}
																setUnconsumedDoseEntries={setUnconsumedDoseEntries}
																unconsumedDoseErrors={unconsumedDoseErrors}
																setUnconsumedDoseErrors={setUnconsumedDoseErrors}
																isActiveDeliverRxCard={openIndex === index}
															/>

																{patientId !== data?.id ? <>
																	{showData &&
																		<React.Fragment>
																			<Common.Comment showComment={showComment}
																				setShowComment={setShowComment}
																				setComment={setComment} comment={comment} />

																			<Common.DeliveryConsultationDropdown consultation={consultation}
																				setConsultation={setConsultation} />

																			<Common.PatientSignature patientSignature={patientSignature}
																				setPatientSignature={setPatientSignature}
																				showPatientSignature={showPatientSignature}
																				setShowPatientSignature={setShowPatientSignature}
																				isRefused={isRefused}
																				setIsRefused={setIsRefused}
																				isPatientVerified={isPatientVerified}
																				setIsPatientVerified={setIsPatientVerified}
																				signatureErrors={signatureErrors}
																				setSignatureErrors={setSignatureErrors}
																				covid19={covid19}
																				setCovid19={setCovid19}
																				rxData={data?.patients_win_rx_data}
																			/>

																			{pharmacist_assistant_status === 1 ? null :
																				<Common.PharmacistSignature
																					pharmacistSignature={pharmacistSignature}
																					setPharmacistSignature={setPharmacistSignature}
																					showPharmacistSignature={showPharmacistSignature}
																					setShowPharmacistSignature={setShowPharmacistSignature}
																					signatureErrors={signatureErrors}
																					setSignatureErrors={setSignatureErrors}
																				/>}


																		</React.Fragment>
																	}

																{!isRouteAllowed && (
																	<Common.RouteAccessBlockedNotice
																		data={data}
																		pharmacyId={pharmacyId}
																		enableNotifyAssignedUser={deliveryTab === 'others'}
																	/>
																)}
																	<div className="flex items-center gap-2">
																		<VideoCallButton
																			data={data}
																			variant="cta"
																			disabled={noRxSelected || !isRouteAllowed}
																			label="Video call"
																		/>
																		{!showData &&
																			<button
																				className={`px-4 flex-1 py-2 rounded-md ${(noRxSelected || !isRouteAllowed) ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-red-500 text-white'}`}
																				disabled={noRxSelected || !isRouteAllowed}
																				onClick={() => {
																					if (noRxSelected || !isRouteAllowed) return;
																					setMissedData(data);
																					setMissedIndex(index);
																					setMissedExplanation('');
																					setMissedExplanationError('');
																					setMissedDeliveryConfirmation(true);
																				}}>
																				Missed
																			</button>}

																		{showData ?
																			
																				showFlexiConfirmation ?
																					<button className="px-4 flex-1 py-2 bg-[#10b981] text-white rounded-md"
																						onClick={() => {
																							window.location.reload();
																						}}
																					>
																						Reload
																					</button>
																					:
																					<button
																						className={`px-4 flex-1 py-2 rounded-md ${(noRxSelected || !isRouteAllowed || confirmDeliveryResponse?.loading) ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#10b981] text-white'}`}
																						disabled={noRxSelected || !isRouteAllowed || confirmDeliveryResponse?.loading}
																						onClick={() => {
																							if (noRxSelected || !isRouteAllowed || confirmDeliveryResponse?.loading) return;
																							handleConfirmDelivery(data, index);
																						}}>
																						{confirmDeliveryResponse?.loading ? <p className='flex justify-center items-center'><Loading.Loader /></p> : 'Continue'}
																					</button>
																			:
																			<button
																				className={`px-4 flex-1 py-2 rounded-md ${(noRxSelected || !isRouteAllowed) ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#10b981] text-white'}`}
																				disabled={noRxSelected || !isRouteAllowed}
																				onClick={() => {
																					if (noRxSelected || !isRouteAllowed) return;
																					setShowData(true);
																					setTimeout(() => {
																						const windowHeight = window.innerHeight;
																						const scrollAmount = windowHeight / 2;
																						window.scrollBy({ top: scrollAmount, behavior: "smooth" });
																					}, 100);
																				}}
																			>
																				Deliver
																			</button>
																		}
																	</div>
																</> : null}
															</>
														</PatientDetails>
														{appointmentDelivery ? (
															<DriverAppointmentCallPanel
																patient={data}
																appointmentDelivery={appointmentDelivery}
															/>
														) : null}
													</div>
												</React.Fragment>);
											})}
							</div>

							{
								loadMore &&
								<div className='flex mb-2'>
									<div className="loaderss"></div>
								</div>
							}

						</div>

						{showToast && <Messages.PickedUpSuccessfully setShowToast={setShowToast} />}
						{showErrorToast && (
							<Messages.DeliveryErrorMessages
								setShowErrorToast={setShowErrorToast}
								message={confirmDeliveryResponse?.userFacingErrorMessage}
								onDismiss={() => dispatch(clearConfirmDeliveryUserMessage())}
							/>
						)}

						{showSuccessToast && <Messages.DeliverSuccessfull setShowSuccessToast={setShowSuccessToast} />}
						{missedDeliverErrorToast && (
							<Messages.MissedDeliveryErrorMessages
								setMissedDeliveryErrorToast={setMissedDeliveryErrorToast}
								message={updateDeliveryListResponse?.userFacingErrorMessage}
								onDismiss={() => dispatch(clearUpdateDeliveryUserMessage())}
							/>
						)}
						{delveryDoneByAnotherDriver && <Messages.DeliveryDoneByAnotherDriver setMissedDeliveryErrorToast={setDeliveryDoneByAnotherDriver} message={delveryDoneByAnotherDriver} />}

					</div>

					{missedDeliveryConfirmation &&
						<MissedDeliveryConfirmation
							setShowConfirmationModal={setMissedDeliveryConfirmation}
							showConfirmationModal={missedDeliveryConfirmation}
							pharmacyId={pharmacyId} handleMissedDelivery={handleMissedDelivery}
							missedData={missedData}
							missedExplanation={missedExplanation}
							setMissedExplanation={setMissedExplanation}
							missedExplanationError={missedExplanationError}
							setMissedExplanationError={setMissedExplanationError}
							isSubmitting={updateDeliveryListResponse?.loading}
						/>}

					<PendingDispenseDeliveredByAnotherDriverAblyHelper
						apiKey={apiKey}
						deliveryDriverDeliveredDispense={deliveryDriverDeliveredDispense}
						pharmacyId={pharmacyId}
						driverID={driverID}
						pId={pId}
						routeName={routeNames}
						setPatientID={setPatientID}
						setDeliveryDoneByAnotherDriver={setDeliveryDoneByAnotherDriver}
						dispatch={dispatch}
						removePatientById={removePatientById}
						setOpenIndex={setOpenIndex}
						setPId={setPId}
						setCordinate={setCordinate}
					/>

					{/* <FlexiRxStatusWarningModal
						rxNumbers={flexiRxNumbers}
						showModal={showFlexiConfirmation}
						setShowModal={setShowFlexiConfirmation}
					// onConfirm={() => handleConfirmDelivery(patientsData)}
					// onCancel={() => setShowFlexiConfirmation(false)}
					/> */}
				</div>
			</>
				: <PageNotFound />}
		</>
	)
}

export default PendingDispense
